module.exports = __webpack_public_path__ + "static/media/intro1.db7e6e14.png";